import { render } from "./MainUserDetails.vue?vue&type=template&id=0c796d7b&scoped=true"
import script from "./MainUserDetails.vue?vue&type=script&lang=js"
export * from "./MainUserDetails.vue?vue&type=script&lang=js"

import "./MainUserDetails.vue?vue&type=style&index=0&id=0c796d7b&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c796d7b"]])

export default __exports__